<div class="skeleton" [style]="style"></div>
